import { useState } from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({ label }) => {
	const [checked, setChecked] = useState(false);

	const change = () => {
		setChecked(!checked);
	};

	return (
		<div className='inline-flex items-center'>
			<label className='flex items-center cursor-pointer relative select-none' htmlFor='check-2'>
				<input
					type='checkbox'
					checked={checked}
					onChange={change}
					className='peer h-6 w-6 cursor-pointer transition-all appearance-none rounded shadow hover:bg-checkbox-hover peer-hover:bg-checkbox-hover border border-default checked:bg-slate-800 checked:border-slate-800'
					id='check-2'
				/>
				<span className='absolute text-white opacity-0 pointer-events-none peer-hover:text-checkbox-on-hover peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						className='h-4 w-4'
						viewBox='0 0 20 20'
						fill='currentColor'
						stroke='currentColor'
						strokeWidth='1'
					>
						<path
							fillRule='evenodd'
							d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
							clipRule='evenodd'
						/>
					</svg>
				</span>
			</label>
			<label className='cursor-pointer ml-2 text-slate-600 text-sm select-none' htmlFor='check-2'>
				{label}
			</label>
		</div>
	);
};

Checkbox.propTypes = {
	label: PropTypes.string,
};

export default Checkbox;
